import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Box } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIoContext } from '~/contexts';
import { useNativeSplashOverlay } from './hooks/useNativeSplashOverlay';
import styles from './NativeSplashOverlay.module.scss';
export const GetNativeSplashOverlayTID = (parentTestId)=>getTestIds(parentTestId);
export const NativeSplashOverlay = (param)=>{
    let { testId, fadeOutMs = 300, hideSafetyMs = 5000 } = param;
    const { Lottie } = useIoContext();
    const { NativeSplashOverlayTestIds } = useMemo(()=>GetNativeSplashOverlayTID(testId), [
        testId
    ]);
    const { phase, animationData, onFirstFramePainted } = useNativeSplashOverlay({
        fadeOutMs,
        hideSafetyMs
    });
    if (phase === 'done') return null;
    return /*#__PURE__*/ _jsx(Box, {
        testId: NativeSplashOverlayTestIds.Root(),
        className: cn(styles.overlay, {
            [styles.fading]: phase === 'fading'
        }),
        style: {
            transitionDuration: "".concat(fadeOutMs, "ms")
        },
        children: animationData != null && /*#__PURE__*/ _jsx(Lottie, {
            animationData: animationData,
            autoplay: true,
            loop: true,
            onDOMLoaded: onFirstFramePainted,
            className: styles.lottie
        })
    });
};
